{
  "payroll.title": "المرتبات",
  "payroll.month.title": "مرتبات {month}",
  "payroll.month.subtitle": "يُحسب لحظيًا وهو مسودة، ويُحفظ نهائيًا بعد القفل.",
  "payroll.month.pick": "شهر المرتبات",
  "payroll.month.previous": "الشهر السابق",
  "payroll.month.next": "الشهر التالي",
  "payroll.month.loadError": "تعذّر تحميل هذا الشهر",
  "payroll.tabs.label": "أقسام شهر المرتبات",
  "payroll.tabs.sheet": "الكشف",
  "payroll.tabs.summary": "ملخص المدير التنفيذي",
  "payroll.tabs.entries": "البنود",
  "payroll.tabs.advances": "السلف",
  "payroll.tabs.claims": "استرداد المصروفات",
  "payroll.status.draft": "مسودة",
  "payroll.status.final": "نهائي",
  "payroll.status.locked": "مقفل",
  "payroll.value.none": "غير مُسجَّل",
  "payroll.filter.all": "الكل",
  "payroll.step.label": "مراحل الشهر",
  "payroll.step.draft": "مسودة",
  "payroll.step.final": "نهائي",
  "payroll.step.locked": "مقفل",
  "payroll.step.paid": "تم الصرف",
  "payroll.step.done": "(تم)",
  "payroll.step.draftCaption": "يُحسب لحظيًا",
  "payroll.step.paidCaption": "صُرف {done} من {total}",
  "payroll.step.payDate": "تاريخ الصرف {date}",
  "payroll.actions.finalize": "اعتماد مرتبات الشهر",
  "payroll.actions.reopen": "إعادة الفتح",
  "payroll.actions.lock": "قفل الشهر",
  "payroll.actions.correct": "تسجيل تسوية",
  "payroll.actions.bankFile": "ملف البنك (CSV)",
  "payroll.actions.blocked": "{count, plural, zero {لا توجد بنود للمراجعة.} one {بند واحد يحتاج مراجعة قبل اعتماد الشهر.} two {بندان يحتاجان مراجعة قبل اعتماد الشهر.} few {# بنود تحتاج مراجعة قبل اعتماد الشهر.} many {# بندًا تحتاج مراجعة قبل اعتماد الشهر.} other {# بند تحتاج مراجعة قبل اعتماد الشهر.}}",
  "payroll.finalize.title": "اعتماد شهر {month}؟",
  "payroll.finalize.body": "يُحدَّد صرف الشهر في أول يوم من الشهر التالي، ولا يمكن إضافة بنود جديدة له. ويمكنك إعادة فتحه ما لم يُقفل.",
  "payroll.finalize.confirm": "اعتماد الشهر",
  "payroll.finalize.pending": "جارٍ الاعتماد…",
  "payroll.finalize.done": "اعتُمد شهر {month}.",
  "payroll.reopen.title": "إعادة فتح شهر {month}؟",
  "payroll.reopen.body": "يعود الشهر مسودة: يمكن إضافة البنود مجددًا، وتُحسب أرقامه لحظيًا.",
  "payroll.reopen.confirm": "إعادة الفتح",
  "payroll.reopen.pending": "جارٍ إعادة الفتح…",
  "payroll.reopen.done": "عاد شهر {month} مسودة.",
  "payroll.lock.title": "قفل شهر {month}؟",
  "payroll.lock.description": "القفل نهائي، ويحفظ الشهر كما هو:",
  "payroll.lock.storesPayslips": "تُحفظ كل قسيمة ببنودها ومدخلاتها.",
  "payroll.lock.locksAttendance": "يُقفل حضور الشهر كذلك.",
  "payroll.lock.settlesEntries": "تُعلَّم الأقساط كمخصومة وتُسوّى التسويات المفتوحة.",
  "payroll.lock.correctionsAfter": "بعد ذلك تُسجَّل أي تغييرات كتسويات في شهر لاحق.",
  "payroll.lock.typeLabel": "اكتب {month} للتأكيد",
  "payroll.lock.typeHint": "اكتبه كما هو تمامًا بصيغة السنة-الشهر.",
  "payroll.lock.confirm": "قفل الشهر",
  "payroll.lock.locking": "جارٍ القفل…",
  "payroll.lock.done": "أُقفل شهر {month}.",
  "payroll.locked.title": "هذا الشهر مقفل",
  "payroll.locked.body": "حُفظت قسائمه نهائيًا. لأي تغيير سجّل تسوية تُسوّى في الشهر التالي عند قفله.",
  "payroll.blockers.title": "{count, plural, zero {لا بنود للمراجعة} one {بند واحد للمراجعة قبل الاعتماد} two {بندان للمراجعة قبل الاعتماد} few {# بنود للمراجعة قبل الاعتماد} many {# بندًا للمراجعة قبل الاعتماد} other {# بند للمراجعة قبل الاعتماد}}",
  "payroll.blockers.people": "{count, plural, zero {· لا أحد} one {· موظف واحد} two {· موظفان} few {· # موظفين} many {· # موظفًا} other {· # موظف}}",
  "payroll.blockers.showNames": "عرض الأسماء",
  "payroll.blockers.recheck": "إعادة الفحص",
  "payroll.blocker.attendance_not_final": "الحضور لم يُعتمد نهائيًا",
  "payroll.blocker.missing_hire_date": "تاريخ التعيين غير مُسجَّل",
  "payroll.blocker.missing_salary": "الراتب غير مُسجَّل",
  "payroll.blocker.dates_inconsistent": "تواريخ التعيين غير متسقة",
  "payroll.blocker.attendance_review": "الحضور يحتاج مراجعة",
  "payroll.blocker.pending_requests": "طلبات في انتظار القرار",
  "payroll.blocker.pending_adjustments": "بنود في انتظار الاعتماد",
  "payroll.blocker.overtime_basis_missing": "لا يوجد أساس لحساب الإضافي",
  "payroll.blocker.settlement_pending": "التسوية النهائية لم تُؤكَّد",
  "payroll.blocker.negative_net": "الصافي بالسالب",
  "payroll.blockerHint.attendance_not_final": "يجب اعتماد حضور هذا الشهر نهائيًا قبل المرتبات.",
  "payroll.blockerHint.missing_hire_date": "أضف تاريخ التعيين إلى الملف الوظيفي.",
  "payroll.blockerHint.missing_salary": "أضف الراتب من تبويب المرتب في ملف الموظف.",
  "payroll.blockerHint.dates_inconsistent": "آخر يوم عمل يسبق تاريخ التعيين. صحّح الملف الوظيفي.",
  "payroll.blockerHint.attendance_review": "بصمات ناقصة أو أيام تحتاج قرارًا؛ احسمها من شاشة الحضور.",
  "payroll.blockerHint.pending_requests": "طلبات إجازة أو حضور في هذا الشهر ما زالت تنتظر القرار.",
  "payroll.blockerHint.pending_adjustments": "اعتمدها أو ارفضها؛ فهي لا تُحتسب قبل ذلك.",
  "payroll.blockerHint.overtime_basis_missing": "اعتُمد عمل إضافي لكن لا يوجد راتب يُحسب منه. أضف الراتب (أو أساس الإضافي) من تبويب المرتب في ملف الموظف.",
  "payroll.blockerHint.settlement_pending": "أكّد أيام رصيد الإجازات من تبويب المرتب في ملف الموظف.",
  "payroll.blockerHint.negative_net": "الخصومات أكبر من المستحق. افتح القسيمة وراجع بنودها.",
  "payroll.blockerAction.attendance": "مراجعة الحضور",
  "payroll.blockerAction.requests": "فتح الطلبات",
  "payroll.blockerAction.entries": "مراجعة البنود",
  "payroll.table.caption": "كشف المرتبات",
  "payroll.table.currency": "المبالغ بعملة {code}",
  "payroll.table.open": "فتح قسيمة {name}",
  "payroll.table.actions": "إجراءات",
  "payroll.table.empty.title": "لا يوجد من يُصرف له",
  "payroll.table.empty.body": "لا يوجد موظفون بملفات وظيفية خلال هذا الشهر.",
  "payroll.column.code": "الكود",
  "payroll.column.name": "الاسم",
  "payroll.column.employee": "الموظف",
  "payroll.column.salary": "الراتب",
  "payroll.column.payableDays": "الأيام المدفوعة",
  "payroll.column.basic": "الأساسي",
  "payroll.column.deductionDays": "أيام الخصم",
  "payroll.column.attendance": "خصم الحضور",
  "payroll.column.overtime": "الإضافي",
  "payroll.column.additions": "الإضافات",
  "payroll.column.deductions": "خصومات أخرى وأقساط",
  "payroll.column.net": "الصافي",
  "payroll.column.netWithCurrency": "الصافي (ج.م)",
  "payroll.column.change": "عن الشهر الماضي",
  "payroll.column.paid": "الصرف",
  "payroll.column.total": "الإجمالي",
  "payroll.change.none": "لا يوجد شهر مقفل سابق للمقارنة",
  "payroll.change.previous": "صافي الشهر الماضي: {amount}",
  "payroll.change.large": "تغيّر بأكثر من {percent} عن الشهر الماضي",
  "payroll.paid.yes": "تم الصرف",
  "payroll.paid.no": "لم يُصرف",
  "payroll.paid.toggle": "تم الصرف: {name}",
  "payroll.paid.markedPaid": "سُجّل صرف مرتب {name}.",
  "payroll.paid.markedUnpaid": "أُلغي تسجيل صرف مرتب {name}.",
  "payroll.payslip.title": "قسيمة المرتب",
  "payroll.payslip.label": "قسيمة {name}",
  "payroll.payslip.loadError": "تعذّر تحميل القسيمة",
  "payroll.payslip.blocked": "قيد المراجعة",
  "payroll.payslip.linesCaption": "بنود القسيمة",
  "payroll.payslip.item": "البند",
  "payroll.payslip.amount": "المبلغ",
  "payroll.payslip.net": "الصافي",
  "payroll.facts.salary": "الراتب",
  "payroll.facts.overtimeBasis": "أساس الإضافي",
  "payroll.facts.sameAsSalary": "نفس الراتب",
  "payroll.facts.dayBasis": "أساس الأيام",
  "payroll.facts.dailyHours": "ساعات اليوم",
  "payroll.facts.payableDays": "أيام الاستحقاق",
  "payroll.facts.deductionDays": "أيام الخصم",
  "payroll.facts.days": "{count, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}",
  "payroll.line.basic": "الأساسي",
  "payroll.line.attendance": "خصم الحضور",
  "payroll.line.overtime_day": "إضافي نهاري",
  "payroll.line.overtime_night": "إضافي ليلي",
  "payroll.line.rest_day_work": "عمل في يوم الراحة",
  "payroll.line.holiday_work": "عمل في عطلة رسمية",
  "payroll.line.bonus": "مكافأة",
  "payroll.line.allowance": "بدل",
  "payroll.line.reimbursement": "استرداد مصروفات",
  "payroll.line.deduction": "خصم",
  "payroll.line.advance": "قسط سلفة",
  "payroll.line.correction": "تسوية",
  "payroll.line.leave_encashment": "صرف رصيد الإجازات",
  "payroll.line.reduced_pay_leave": "إجازة بأجر مخفّض",
  "payroll.line.unpaid_permission": "وقت إذن غير مدفوع",
  "payroll.formula.legend.basic": "الراتب ÷ أساس الأيام × أيام الاستحقاق",
  "payroll.formula.legend.attendance": "الراتب ÷ أساس الأيام × أيام الخصم",
  "payroll.formula.legend.encashment": "آخر راتب ÷ أساس الأيام × أيام الإجازة المصروفة",
  "payroll.formula.legend.wageDays": "أساس الإضافي ÷ أساس الأيام × الأيام",
  "payroll.formula.legend.hourly": "أساس الإضافي ÷ أساس الأيام ÷ ساعات اليوم × المعامل × الساعات",
  "payroll.formula.legend.unit": "الكمية × قيمة الوحدة",
  "payroll.formula.legend.reducedPay": "الجزء غير المدفوع من أيام الإجازة × قيمة اليوم",
  "payroll.formula.legend.permission": "الساعات × قيمة ساعة اليوم",
  "payroll.formula.legend.rounded": "الكمية × قيمة الوحدة مقرّبة للعرض؛ أما المبلغ فدقيق.",
  "payroll.source.entry": "فتح البند",
  "payroll.source.advance": "فتح السلفة",
  "payroll.source.overtime": "فتح الإضافي",
  "payroll.source.attendance": "فتح الحضور",
  "payroll.source.salary": "فتح سجل الرواتب",
  "payroll.source.settlement": "فتح التسوية النهائية",
  "payroll.summary.agency": "404 Creative",
  "payroll.summary.title": "ملخص مرتبات {month}",
  "payroll.summary.caption": "صافي مرتبات {month}",
  "payroll.summary.payDate": "تاريخ الصرف: {date}",
  "payroll.summary.payDateLater": "يتحدد تاريخ الصرف عند اعتماد الشهر.",
  "payroll.summary.underReview": "قيد المراجعة",
  "payroll.summary.totalHidden": "مخفي: {count, plural, zero {لا بنود} one {بند واحد} two {بندان} few {# بنود} many {# بندًا} other {# بند}} قيد المراجعة",
  "payroll.summary.reviewNotice": "{count, plural, zero {لا توجد بنود قيد المراجعة.} one {بند واحد قيد المراجعة؛ يبقى صافي صاحبه والإجمالي مخفيين حتى تحسمه.} two {بندان قيد المراجعة؛ يبقى صافي أصحابهما والإجمالي مخفيين حتى تحسمهما.} few {# بنود قيد المراجعة؛ يبقى صافي أصحابها والإجمالي مخفيين حتى تحسمها.} many {# بندًا قيد المراجعة؛ يبقى صافي أصحابها والإجمالي مخفيين حتى تحسمها.} other {# بند قيد المراجعة؛ يبقى صافي أصحابها والإجمالي مخفيين حتى تحسمها.}}",
  "payroll.summary.paidCount": "صُرفت {done} من {total} قسيمة",
  "payroll.summary.paidLater": "يظهر تسجيل الصرف بعد قفل الشهر.",
  "payroll.summary.print": "طباعة",
  "payroll.summary.preparedBy": "أعدّه",
  "payroll.summary.approvedBy": "اعتمده",
  "payroll.adjustments.title": "الإضافات والخصومات",
  "payroll.adjustments.description": "المكافآت والبدلات واستردادات المصروفات والخصومات المُدخلة يدويًا لهذا الشهر.",
  "payroll.adjustments.closed": "لم يعد هذا الشهر مسودة، فلا يمكن تعديل بنوده. أعد فتحه، أو سجّل تسوية بعد قفله.",
  "payroll.adjustments.filter": "تصفية البنود حسب الحالة",
  "payroll.adjustments.loadError": "تعذّر تحميل بنود هذا الشهر.",
  "payroll.adjustments.empty.title": "لا توجد بنود بعد",
  "payroll.adjustments.empty.body": "ستظهر هنا مكافآت هذا الشهر وبدلاته وخصوماته.",
  "payroll.adjustment.title": "بند جديد",
  "payroll.adjustment.description": "يُحتسب في هذا الشهر بعد اعتماده.",
  "payroll.adjustment.add": "إضافة بند",
  "payroll.adjustment.submit": "إضافة البند",
  "payroll.adjustment.added": "أُضيف البند، ويُحتسب بعد اعتماده.",
  "payroll.adjustment.kind": "النوع",
  "payroll.adjustment.kind.bonus": "مكافأة",
  "payroll.adjustment.kind.allowance": "بدل",
  "payroll.adjustment.kind.reimbursement": "استرداد مصروفات",
  "payroll.adjustment.kind.deduction": "خصم",
  "payroll.adjustment.adds": "يُضاف إلى الصافي",
  "payroll.adjustment.subtracts": "يُخصم من الصافي",
  "payroll.adjustment.date": "تاريخ الاحتساب",
  "payroll.adjustment.statusLabel": "الحالة",
  "payroll.adjustment.status.pending": "في انتظار الاعتماد",
  "payroll.adjustment.status.approved": "معتمد",
  "payroll.adjustment.status.rejected": "مرفوض",
  "payroll.adjustment.addedBy": "أضافه {name} · {when}",
  "payroll.adjustment.decidedBy": "قرّره {name} · {when}",
  "payroll.adjustment.approve": "اعتماد",
  "payroll.adjustment.approveFor": "اعتماد بند {name}",
  "payroll.adjustment.approved": "اعتُمد البند.",
  "payroll.adjustment.reject": "رفض",
  "payroll.adjustment.rejectFor": "رفض بند {name}",
  "payroll.adjustment.rejectTitle": "رفض بند {name}؟",
  "payroll.adjustment.rejectBody": "يبقى البند مسجّلًا كمرفوض ولا يُصرف.",
  "payroll.adjustment.rejected": "رُفض البند.",
  "payroll.adjustment.remove": "حذف",
  "payroll.adjustment.removeFor": "حذف بند {name}",
  "payroll.adjustment.removeTitle": "حذف بند {name}؟",
  "payroll.adjustment.removeBody": "لم يُبتّ فيه بعد، فحذفه لا يؤثر على المرتب.",
  "payroll.adjustment.removed": "حُذف البند.",
  "payroll.corrections.title": "التسويات",
  "payroll.corrections.description": "الشهر المقفل لا يتغير. المبالغ المستحقة أو المصروفة بالزيادة تُسجَّل كتسوية تُسوّى في الشهر التالي عند قفله، وتظهر بندًا في القسيمة.",
  "payroll.correction.title": "تسوية شهر مقفل",
  "payroll.correction.description": "مبلغ مستحق أو مصروف بالزيادة عن شهر مقفل، يُصرف أو يُسترد في الشهر التالي عند قفله.",
  "payroll.correction.month": "الشهر المقفل",
  "payroll.correction.noLocked": "لم يُقفل أي شهر بعد، فلا يوجد ما يُسوّى.",
  "payroll.correction.direction": "نوع التسوية",
  "payroll.correction.owed": "مستحق للموظف",
  "payroll.correction.owedHint": "يُصرف مع الراتب التالي.",
  "payroll.correction.overpaid": "مصروف بالزيادة",
  "payroll.correction.overpaidHint": "يُسترد من الراتب التالي.",
  "payroll.correction.submit": "تسجيل التسوية",
  "payroll.correction.recorded": "سُجّلت التسوية، وتُسوّى في الشهر التالي عند قفله.",
  "payroll.form.person": "الموظف",
  "payroll.form.personPlaceholder": "اختر موظفًا",
  "payroll.form.personSearch": "ابحث بالاسم أو الكود",
  "payroll.form.personEmpty": "لا يوجد تطابق.",
  "payroll.form.amount": "المبلغ (ج.م)",
  "payroll.form.reason": "السبب",
  "payroll.form.saving": "جارٍ الحفظ…",
  "payroll.form.errors.amount": "اكتب مبلغًا أكبر من صفر، بحد أقصى رقمين عشريين.",
  "payroll.form.errors.reason": "اكتب سببًا من ٣ حروف على الأقل.",
  "payroll.form.errors.tooLong": "النص أطول من المسموح.",
  "payroll.form.errors.date": "اختر تاريخًا.",
  "payroll.form.errors.person": "اختر الموظف.",
  "payroll.form.errors.month": "اختر شهرًا مقفلًا.",
  "payroll.advances.title": "السلف",
  "payroll.advances.description": "السلف على الراتب والأقساط التي تستردها.",
  "payroll.advances.filter": "تصفية السلف حسب الحالة",
  "payroll.advances.loadError": "تعذّر تحميل السلف.",
  "payroll.advances.empty.title": "لا توجد سلف",
  "payroll.advances.empty.body": "ستظهر هنا السلف وأقساطها.",
  "payroll.advances.emptyFilter": "لا توجد سلف بهذه الحالة",
  "payroll.advance.add": "سلفة جديدة",
  "payroll.advance.title": "سلفة جديدة",
  "payroll.advance.description": "تُصرف مقدمًا من الراتب وتُسترد على أقساط شهرية.",
  "payroll.advance.total": "إجمالي السلفة (ج.م)",
  "payroll.advance.installments": "عدد الأقساط",
  "payroll.advance.firstMonth": "أول قسط",
  "payroll.advance.preview": "خطة الأقساط",
  "payroll.advance.previewEmpty": "اكتب إجمالي السلفة وعدد الأقساط لتظهر الخطة.",
  "payroll.advance.installmentNumber": "القسط {number}",
  "payroll.advance.errors.installments": "اكتب عددًا صحيحًا من ١ إلى ٣٦.",
  "payroll.advance.submit": "تسجيل السلفة",
  "payroll.advance.added": "سُجّلت السلفة.",
  "payroll.advance.remainingOf": "متبقٍ {amount} من {total}",
  "payroll.advance.status.active": "سارية",
  "payroll.advance.status.settled": "مسددة",
  "payroll.advance.status.cancelled": "ملغاة",
  "payroll.advance.cancel": "إلغاء السلفة",
  "payroll.advance.cancelTitle": "إلغاء هذه السلفة؟",
  "payroll.advance.cancelBody": "ستُعفى الأقساط المتبقية ({amount}) ولن تُخصم.",
  "payroll.advance.cancelled": "أُلغيت السلفة.",
  "payroll.installment.status.scheduled": "مجدول",
  "payroll.installment.status.deducted": "مخصوم",
  "payroll.installment.status.postponed": "مؤجل",
  "payroll.installment.status.waived": "معفى",
  "payroll.installment.postpone": "تأجيل",
  "payroll.installment.postponeMonth": "تأجيل قسط {month}",
  "payroll.installment.postponeTitle": "تأجيل قسط {month}؟",
  "payroll.installment.postponeBody": "ينتقل القسط إلى ما بعد آخر قسط، ويُحفظ السبب معه.",
  "payroll.installment.postponed": "أُجّل قسط {month}.",
  "payroll.claims.title": "طلبات استرداد المصروفات",
  "payroll.claims.description": "يبت المديرون والموارد البشرية في الطلبات من شاشة الطلبات، ويُرد المقبول منها في أول شهر مفتوح.",
  "payroll.claims.decide": "البت من الطلبات",
  "payroll.claims.filter": "تصفية الطلبات حسب الحالة",
  "payroll.claims.loadError": "تعذّر تحميل طلبات الاسترداد.",
  "payroll.claims.empty.title": "لا توجد طلبات استرداد",
  "payroll.claims.empty.body": "ستظهر هنا الطلبات بهذه الحالة.",
  "payroll.claim.new": "طلب استرداد مصروفات",
  "payroll.claim.newTitle": "طلب استرداد مصروفات",
  "payroll.claim.newDescription": "يقرره مديرك ثم الموارد البشرية، وبعد قبوله يُضاف إلى راتبك التالي.",
  "payroll.claim.spentOn": "تاريخ الإنفاق",
  "payroll.claim.category": "الفئة",
  "payroll.claim.categoryHint": "اختر فئة أو اكتب فئتك.",
  "payroll.claim.description": "الغرض منها",
  "payroll.claim.receipt": "الإيصال",
  "payroll.claim.receiptHint": "ملف PDF أو صورة، حتى ١٠ ميجابايت.",
  "payroll.claim.noReceipt": "بدون إيصال",
  "payroll.claim.openReceipt": "فتح الإيصال {name}",
  "payroll.claim.attachReceipt": "إرفاق الإيصال",
  "payroll.claim.replaceReceipt": "استبدال الإيصال",
  "payroll.claim.receiptAttached": "أُرفق الإيصال.",
  "payroll.claim.submit": "إرسال الطلب",
  "payroll.claim.sent": "أُرسل الطلب للاعتماد.",
  "payroll.claim.sentWithoutReceipt": "أُرسل الطلب لكن لم يُرفع الإيصال. أرفقه من القائمة.",
  "payroll.claim.withdraw": "سحب الطلب",
  "payroll.claim.withdrawTitle": "سحب هذا الطلب؟",
  "payroll.claim.withdrawBody": "لن يُطلب من أحد البت فيه بعد الآن.",
  "payroll.claim.withdrawn": "سُحب الطلب.",
  "payroll.claim.statusLabel": "الحالة",
  "payroll.claim.status.pending": "قيد المراجعة",
  "payroll.claim.status.approved": "مقبول",
  "payroll.claim.status.rejected": "مرفوض",
  "payroll.claim.status.cancelled": "مسحوب",
  "payroll.claim.errors.category": "اكتب فئة من حرفين على الأقل.",
  "payroll.claim.errors.description": "اكتب الغرض منها في كلمات قليلة.",
  "payroll.claim.errors.receiptType": "أرفق ملف PDF أو صورة PNG أو JPEG أو WebP.",
  "payroll.claim.errors.receiptSize": "حجم الإيصال أكبر من ١٠ ميجابايت.",
  "payroll.claim.categories.transport": "مواصلات",
  "payroll.claim.categories.meals": "وجبات",
  "payroll.claim.categories.supplies": "مستلزمات",
  "payroll.claim.categories.software": "برمجيات",
  "payroll.claim.categories.travel": "سفر",
  "payroll.claim.categories.other": "أخرى",
  "payroll.flow.step": "{role}: {status}",
  "payroll.flow.manager": "المدير",
  "payroll.flow.hr": "الموارد البشرية",
  "payroll.flow.waiting": "في الانتظار",
  "payroll.flow.current": "يقرر الآن",
  "payroll.flow.approved": "وافق",
  "payroll.flow.rejected": "رفض",
  "payroll.flow.skipped": "تُخطّي",
  "payroll.pay.title": "المرتب",
  "payroll.pay.description": "الراتب وطريقة صرفه والسلف والتسوية النهائية.",
  "payroll.compensation.title": "الراتب",
  "payroll.compensation.description": "صافي الراتب الشهري من كل تاريخ، والأجر الذي يُحسب عليه الإضافي.",
  "payroll.compensation.add": "راتب جديد",
  "payroll.compensation.addTitle": "راتب جديد",
  "payroll.compensation.addDescription": "راتب {name} اعتبارًا من تاريخ. وإن وُجد راتب بنفس التاريخ يحل هذا محله.",
  "payroll.compensation.from": "ساري من",
  "payroll.compensation.fromHint": "أول يوم يُطبَّق فيه الراتب.",
  "payroll.compensation.fromDate": "من {date}",
  "payroll.compensation.net": "صافي الراتب الشهري (ج.م)",
  "payroll.compensation.overtimeBasis": "أساس الإضافي (ج.م)",
  "payroll.compensation.overtimeBasisHint": "اتركه فارغًا ليُحسب الإضافي على صافي الراتب.",
  "payroll.compensation.basisValue": "أساس الإضافي {amount}",
  "payroll.compensation.basisSame": "الإضافي يُحسب على صافي الراتب",
  "payroll.compensation.reason": "السبب (اختياري)",
  "payroll.compensation.submit": "حفظ الراتب",
  "payroll.compensation.saved": "حُفظ الراتب.",
  "payroll.compensation.current": "الحالي",
  "payroll.compensation.upcoming": "قادم",
  "payroll.compensation.loadError": "تعذّر تحميل سجل الرواتب.",
  "payroll.compensation.empty.title": "لم يُسجَّل راتب بعد",
  "payroll.compensation.empty.body": "أضف راتب {name} ليُحسب مرتبه الشهري.",
  "payroll.payment.title": "بيانات الصرف",
  "payroll.payment.description": "أين يُصرف مرتب هذا الموظف.",
  "payroll.payment.method": "طريقة الصرف",
  "payroll.payment.bank": "البنك",
  "payroll.payment.account": "رقم الحساب",
  "payroll.payment.accountHint": "IBAN أو رقم الحساب أو المحفظة أو عنوان إنستاباي. يُحفظ مشفّرًا ولا يظهر منه إلا آخر أربعة.",
  "payroll.payment.notes": "ملاحظات",
  "payroll.payment.reveal": "كشف",
  "payroll.payment.hide": "إخفاء",
  "payroll.payment.add": "إضافة",
  "payroll.payment.edit": "تعديل",
  "payroll.payment.addTitle": "بيانات الصرف",
  "payroll.payment.editTitle": "تعديل بيانات الصرف",
  "payroll.payment.editDescription": "أين يُصرف مرتب {name}.",
  "payroll.payment.editAudited": "الحفظ يستبدل الحساب المسجّل، لذا يُعرض هنا كاملًا وتُسجَّل هذه القراءة.",
  "payroll.payment.auditNotice": "كشف رقم الحساب أو تعديله يعرضه كاملًا، وتُسجَّل كل قراءة في سجل النشاط. ويُخفى مجددًا بعد {seconds} ثانية.",
  "payroll.payment.revealError": "تعذّر قراءة الحساب لتعديله.",
  "payroll.payment.loadError": "تعذّر تحميل بيانات الصرف.",
  "payroll.payment.submit": "حفظ البيانات",
  "payroll.payment.saved": "حُفظت بيانات الصرف.",
  "payroll.payment.methods.bank_transfer": "تحويل بنكي",
  "payroll.payment.methods.instapay": "إنستاباي",
  "payroll.payment.methods.wallet": "محفظة إلكترونية",
  "payroll.payment.methods.cash": "نقدًا",
  "payroll.payment.methods.other": "أخرى",
  "payroll.settlement.title": "التسوية النهائية",
  "payroll.settlement.description": "الشهر الأخير للموظف المغادر: صرف رصيد الإجازات، واسترداد السلف، وتسليم العُهد.",
  "payroll.settlement.loadError": "تعذّر تحميل التسوية النهائية.",
  "payroll.settlement.notDue.title": "لا توجد تسوية نهائية",
  "payroll.settlement.notDue.body": "لم يُسجَّل آخر يوم عمل في الملف. عند تسجيله تظهر التسوية النهائية هنا.",
  "payroll.settlement.state.unconfirmed": "غير مؤكدة",
  "payroll.settlement.state.confirmed": "مؤكدة",
  "payroll.settlement.state.stale": "تحتاج تأكيدًا جديدًا",
  "payroll.settlement.staleTitle": "تغيّر آخر يوم عمل",
  "payroll.settlement.staleBody": "تغيّر بعد تأكيد التسوية. راجع الأيام وأكّد مرة أخرى.",
  "payroll.settlement.unconfirmedBody": "لا يمكن اعتماد الشهر قبل تأكيد أيام الإجازة.",
  "payroll.settlement.confirmedBy": "أكّدها {name} · {when}",
  "payroll.settlement.lastDay": "آخر يوم عمل",
  "payroll.settlement.month": "تُسوّى في",
  "payroll.settlement.suggested": "الرصيد المستحق",
  "payroll.settlement.daysValue": "{days} يوم",
  "payroll.settlement.dayValue": "قيمة اليوم",
  "payroll.settlement.early": "أقساط تُسترد مبكرًا",
  "payroll.settlement.leaveCaption": "رصيد الإجازات المستحق عند المغادرة",
  "payroll.settlement.kind": "الإجازة",
  "payroll.settlement.allowance": "رصيد السنة",
  "payroll.settlement.earned": "المكتسب",
  "payroll.settlement.credits": "إضافات",
  "payroll.settlement.used": "المستخدم",
  "payroll.settlement.due": "المستحق",
  "payroll.settlement.totalDue": "إجمالي المستحق",
  "payroll.settlement.earnedExplained": "المكتسب هو رصيد السنة بنسبة الأيام التقويمية حتى آخر يوم عمل. المستحق = المكتسب + الإضافات − المستخدم.",
  "payroll.settlement.assetsTitle": "{count, plural, zero {لا توجد عُهد} one {عهدة واحدة لم تُسلَّم} two {عهدتان لم تُسلَّما} few {# عُهد لم تُسلَّم} many {# عهدة لم تُسلَّم} other {# عهدة لم تُسلَّم}}",
  "payroll.settlement.assetSince": "منذ {date}",
  "payroll.settlement.daysToPay": "أيام الإجازة المصروفة",
  "payroll.settlement.daysHint": "الرصيد المستحق: {days} يوم.",
  "payroll.settlement.reasonRequired": "السبب",
  "payroll.settlement.reasonOptional": "السبب (اختياري)",
  "payroll.settlement.reasonHint": "مطلوب: الأيام تختلف عن الرصيد المستحق.",
  "payroll.settlement.errors.days": "اكتب عدد الأيام من ٠ إلى ٣٦٥، بحد أقصى رقمين عشريين.",
  "payroll.settlement.errors.reason": "اذكر سبب اختلاف الأيام المصروفة عن الرصيد المستحق.",
  "payroll.settlement.confirm": "تأكيد التسوية",
  "payroll.settlement.confirmAgain": "تأكيد مرة أخرى",
  "payroll.settlement.confirming": "جارٍ التأكيد…",
  "payroll.settlement.confirmed": "أُكّدت التسوية النهائية.",
  "payroll.settlement.monthClosed": "حالة الشهر: {status}. أعد فتحه لتغيير التسوية.",
  "payroll.settlement.remove": "حذف التسوية",
  "payroll.settlement.removeTitle": "حذف التسوية النهائية؟",
  "payroll.settlement.removeBody": "لن تُصرف أيام الإجازة، وينتظر الشهر تأكيدًا جديدًا.",
  "payroll.settlement.removed": "حُذفت التسوية النهائية.",
  "payroll.settlement.preview": "قسيمة الشهر الأخير",
  "payroll.settlement.previewHint": "محسوبة على الوضع الحالي بأيام الإجازة المؤكدة.",
  "payroll.me.payslips": "قسائم مرتبي",
  "payroll.me.payslipsHint": "قسيمة لكل شهر مقفل ببنودها كاملة.",
  "payroll.me.payslipsError": "تعذّر تحميل قسائمك.",
  "payroll.me.empty.title": "لا توجد قسائم بعد",
  "payroll.me.empty.body": "تظهر قسيمة كل شهر هنا بعد قفله.",
  "payroll.me.payDate": "تاريخ الصرف {date}",
  "payroll.me.paidOn": "تم الصرف {date}",
  "payroll.me.payslipTitle": "قسيمة مرتب {month}",
  "payroll.me.back": "مرتبي",
  "payroll.me.print": "طباعة",
  "payroll.me.notLocked.title": "هذه القسيمة غير جاهزة",
  "payroll.me.notLocked.body": "تظهر القسيمة بعد قفل شهرها.",
  "payroll.me.claims": "طلبات استرداد المصروفات",
  "payroll.me.claimsHint": "أرسل ما أنفقته على العمل، ويُضاف المقبول إلى راتبك التالي.",
  "payroll.me.claimsEmpty.title": "لا توجد طلبات بعد",
  "payroll.me.claimsEmpty.body": "اشتريت شيئًا للعمل؟ أرسل طلبًا بإيصاله.",
  "payroll.errors.hasBlockers": "احسم البنود قيد المراجعة قبل اعتماد الشهر.",
  "payroll.errors.state": "هذه الخطوة لا تنطبق على حالة الشهر الآن. أعد التحميل لترى حالته.",
  "payroll.errors.locked": "هذا الشهر مقفل. سجّل تسوية في الشهر التالي بدلًا من ذلك.",
  "payroll.errors.monthConfirmation": "اكتب الشهر كما هو معروض تمامًا لقفله.",
  "payroll.errors.runNotFound": "تعذّر العثور على شهر المرتبات.",
  "payroll.errors.payslipNotFound": "تعذّر العثور على القسيمة.",
  "payroll.errors.adjustmentNotFound": "هذا البند لم يعد موجودًا.",
  "payroll.errors.advanceNotFound": "لم يعد ممكنًا تعديل هذه السلفة أو القسط.",
  "payroll.errors.compensationInvalid": "يجب أن يكون الراتب أكبر من صفر.",
  "payroll.errors.claimNotFound": "تعذّر العثور على طلب الاسترداد.",
  "payroll.errors.settlementNotDue": "سجّل آخر يوم عمل للموظف قبل تسوية مستحقاته.",
  "payroll.errors.settlementNotFound": "لا توجد تسوية نهائية لحذفها.",
  "payroll.errors.employeeNotPaid": "ليس لهذا الشخص ملف وظيفي، فهو ليس ضمن المرتبات.",
  "payroll.errors.periodLocked": "هذا الشهر مقفل.",
  "payroll.errors.conflict": "عدّل شخص آخر هذه البيانات في هذه الأثناء. أعد التحميل وحاول مرة أخرى.",
  "payroll.errors.receipt": "أرفق ملف PDF أو صورة PNG أو JPEG أو WebP حتى ١٠ ميجابايت."
}
